import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { APIWHATSAPP, APIWHATSAPPDNS, PORTWATSAPP } from "@/API.js";

window.Pusher = Pusher;

const getAuthToken = () =>
  localStorage.getItem("argusblack.token") || localStorage.getItem("auth_token") || "";

window.Echo = new Echo({
  broadcaster: "pusher",
  key: "slbhhru36lgdtqbeqyub",
  cluster: "mt1",
  wsHost: APIWHATSAPPDNS,
  wsPort: PORTWATSAPP,
  wssPort: PORTWATSAPP,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ["ws", "wss"],
  debug: true,
  authEndpoint: APIWHATSAPP + "/broadcasting/auth",
  auth: {
    headers: {
      Authorization: getAuthToken(),
      Accept: "application/json",
    },
  },
  withCredentials: false,
});

document.addEventListener('actualizar:token', function(e) {
  if (window.Echo && window.Echo.connector && window.Echo.connector.options && window.Echo.connector.options.auth) {
    window.Echo.connector.options.auth.headers.Authorization = e.detail;
  }
});

const callbacksWhatsappGlobal = new Set();
let canalWhatsappGlobalSuscrito = false;

/**
 * Canal privado 'whatsapp' -> Evento 'WebSocket\ConversacionesWhatsapp'
 */
export function escucharWhatsappGlobal(callback) {
  if (typeof callback === "function") {
    callbacksWhatsappGlobal.add(callback);
  }
  if (!window.Echo || canalWhatsappGlobalSuscrito) return;

  canalWhatsappGlobalSuscrito = true;
  const channel = window.Echo.private("whatsapp");
  channel.stopListening("WebSocket\\ConversacionesWhatsapp");
  channel.listen("WebSocket\\ConversacionesWhatsapp", (data) => {
    callbacksWhatsappGlobal.forEach((cb) => {
      try {
        cb(data);
      } catch (e) {}
    });
  });
}

export function dejarDeEscucharWhatsappGlobal(callback) {
  if (typeof callback === "function") {
    callbacksWhatsappGlobal.delete(callback);
  } else {
    callbacksWhatsappGlobal.clear();
  }

  if (callbacksWhatsappGlobal.size === 0 && window.Echo && canalWhatsappGlobalSuscrito) {
    canalWhatsappGlobalSuscrito = false;
    window.Echo.private("whatsapp").stopListening("WebSocket\\ConversacionesWhatsapp");
    window.Echo.leave("whatsapp");
  }
}

/**
 * Canal privado 'whatsapp.{numeroTelefono}' -> Evento 'WebSocket\MensajeWhatsapp'
 */
export function escucharMensajesConversacion(numeroTelefono, callback) {
  if (!window.Echo || !numeroTelefono) return;

  window.Echo.private(`whatsapp.${numeroTelefono}`)
    .listen("WebSocket\\MensajeWhatsapp", (data) => {
      if (typeof callback === "function") {
        callback(data);
      }
    });
}

export function dejarDeEscucharMensajesConversacion(numeroTelefono) {
  if (!window.Echo || !numeroTelefono) return;
  window.Echo.leave(`whatsapp.${numeroTelefono}`);
}
